import React, { Suspense, useMemo } from "react";
import { useParams } from "react-router-dom";
import { useClient } from "@app/portal-sdk";
import { EmptyState } from "@app/ui-kit";
import { APP_REGISTRY, isAppSlug } from "../apps/registry";
import { LoadingScreen } from "../components/LoadingScreen";

/** Renders a registered client application when the client is entitled to it. */
export const AppRoute = () => {
  const { appSlug = "" } = useParams();
  const { client } = useClient();

  const definition = isAppSlug(appSlug) ? APP_REGISTRY[appSlug] : null;
  const enabled = definition ? client.enabledApps.includes(definition.slug) : false;

  const Component = useMemo(
    () => (definition && enabled ? React.lazy(definition.load) : null),
    [definition, enabled]
  );

  if (!definition) {
    return <EmptyState eyebrow="Not Found" title="That application does not exist" />;
  }
  if (!Component) {
    return (
      <EmptyState
        eyebrow="Not Enabled"
        title={`${definition.name} is not enabled for ${client.name}`}
        description="Contact BKDP if you expected to have access."
      />
    );
  }

  return (
    <Suspense fallback={<LoadingScreen />}>
      <Component />
    </Suspense>
  );
};
